import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

//import style
import styles from './CompanyInfoBox.module.scss';

export default class CompanyInfoBox extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { description, header, logo } = this.props.data;

    return (
      <div className={styles.CompanyInfoBox}>
        <img
          src={OptimizeImagesService.adjustImageSize(logo)}
          className={styles.BoxImage}
          alt="logo"
        />
        <div className={styles.BoxContent}>
          <h3 className={styles.BoxHeader}>{header}</h3>
          <p className={styles.BoxParagraph}>{description}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ChoosenCompany/components/CompanyInfoBox/CompanyInfoBox.js